if (
  globalThis.location.hash.startsWith('#id_token=') ||
  globalThis.location.hash.startsWith('#access_token=')
) {
  globalThis.location.replace('#/auth?' + globalThis.location.hash.slice(1));
}
